import type { ErrorType } from '@rover/rsdk/src/modules/Network/orvalHTTPInterface';

/**
 * Pulls the human-readable message out of a failed verification request. The
 * endpoint reports why a code was rejected as `message` on the response body;
 * a network failure or an unexpected shape falls back to `fallbackMessage`.
 */
export const readErrorMessage = (error: ErrorType<Error>, fallbackMessage: string): string => {
  if ('rawResponse' in error && error.rawResponse) {
    const { message } = (error.rawResponse.data ?? {}) as { message?: string };
    if (message) return message;
  }

  return fallbackMessage;
};
